import React, { useEffect, useState } from "react";
import Papa from "papaparse";

function ScrollableTable() {
  const [data, setData] = useState([]);
  const [headers, setHeaders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 100;

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/Database.csv")
      .then((response) => response.text())
      .then((csvText) => {
        const parsed = Papa.parse(csvText, { header: true });
        if (parsed.data.length > 0) {
          setHeaders(Object.keys(parsed.data[0]));
          setData(parsed.data.filter((row) => Object.values(row).some((v) => v)));
        }
      });
  }, []);

  const paginatedData = data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const handlePrev = () => currentPage > 1 && setCurrentPage(currentPage - 1);
  const handleNext = () => currentPage < totalPages && setCurrentPage(currentPage + 1);

  return (
    <div className="bg-white shadow rounded p-4 mt-10">
      <h2 className="text-2xl font-semibold mb-4">🧾 Database Sample (first 5000 rows) </h2>
      <div className="overflow-x-auto overflow-y-auto max-h-[600px] text-sm">
        <table className="table-auto border-collapse border w-full min-w-[1000px]">
          <thead className="bg-gray-100 sticky top-0">
            <tr>
              {headers.map((header, i) => (
                <th key={i} className="border px-3 py-2 text-left font-semibold text-base">
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedData.map((row, rowIndex) => (
              <tr key={rowIndex} className="even:bg-gray-50">
                {headers.map((header, colIndex) => (
                  <td key={colIndex} className="border px-3 py-1 whitespace-nowrap max-w-[200px] overflow-hidden text-ellipsis">
                    {header === "Translation" && row[header]?.length > 30
                      ? `${row[header].slice(0, 30)}...`
                      : row[header]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="flex justify-between items-center mt-4">
        <button
          onClick={handlePrev}
          disabled={currentPage === 1}
          className="px-3 py-1 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          Previous
        </button>
        <span className="text-gray-700">
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={handleNext}
          disabled={currentPage === totalPages}
          className="px-3 py-1 bg-blue-600 text-white rounded disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default ScrollableTable;